import type { Routes } from '../../shares/types';
import { HandoutBasic } from './basic';

export const HANDOUT_ROUTES: Routes = {
	handout: {
		basic: HandoutBasic,
	},
};
